export default __webpack_public_path__ + "static/media/expTwitter.61fc6b56.svg";